// extracted by mini-css-extract-plugin
module.exports = {"wrap":"da51a739f7--wrap--NUofs","tabs":"da51a739f7--tabs--Zrbum","wrap-left-blur":"da51a739f7--wrap-left-blur--qI6PV","wrap-right-blur":"da51a739f7--wrap-right-blur--acZ4I"};